export default __webpack_public_path__ + "static/media/Abuja1.e019e703.jpg";